function getRoot(){ return document.getElementById('sov-loader-container'); }
function getSOVLoader(){
  var root = getRoot();
  return (root && root.querySelector('.sov-loader')) || document.querySelector('.sov-loader');
}

var __sovShownAt = 0;
var __sovHideTmr = null;
var __SOV_MIN_VISIBLE = 1000; // 1 secondo

function startSOVLoader(){
  var n = getSOVLoader();
  if(!n) return;
  if(__sovHideTmr){ clearTimeout(__sovHideTmr); __sovHideTmr = null; }
  __sovShownAt = performance.now();
  n.style.display = 'block';         // come richiesto: block / none
}

function removeSOVLoader(){
  var n = getSOVLoader();
  if(!n) return;
  var elapsed = performance.now() - __sovShownAt;
  var delay = Math.max(0, __SOV_MIN_VISIBLE - (isFinite(elapsed) ? elapsed : 0));
  if(__sovHideTmr) clearTimeout(__sovHideTmr);
  __sovHideTmr = setTimeout(function(){
    n.style.display = 'none';
    __sovHideTmr = null;
    __sovShownAt = 0;
  }, delay);
}
